/* AEM markets should be provided in this format:
type countryCode = string;
type languageCode = string;
type marketSettings = [countryCode, languageCode[]];
type markets = marketSettings[];
*/

// An array of real AEM markets where components will be published
const REAL_MARKETS = [
  ['AT', ['de']], // Austria
  ['AU', ['en']], // Australia
  ['BE', ['fr', 'nl']], // Belgium
  ['BR', ['pt']], // Brazil
  ['CH', ['de', 'fr', 'it']], // Switzerland
  ['CZ', ['cs']], // Czech Republic
  ['DE', ['de']], // Germany
  ['DK', ['da']], // Denmark
  ['EG', ['ar', 'en']], // Egypt
  ['HU', ['hu']], // Hungary
  ['ID', ['en']], // Indonesia
  ['IN', ['en']], // India
  ['IT', ['it']], // Italy
  ['JP', ['ja']], // Japan
  ['KR', ['ko']], // South Korea
  ['FR', ['fr']], // France
  ['MX', ['es', 'en']], // Mexico
  ['MY', ['en']], // Malaysia
  ['NL', ['nl']], // Netherlands
  ['NZ', ['en']], // New Zealand
  ['LU', ['de', 'fr']], // Luxembourg
  ['PT', ['pt']], // Portugal
  ['PL', ['pl']], // Poland
  ['RO', ['ro']], // Romania
  ['RU', ['ru']], // Russia
  ['SE', ['sv']], // Sweden
  ['SG', ['en']], // Singapore
  ['SK', ['sk']], // Slovakia
  ['ES', ['es']], // Spain
  ['TH', ['en', 'th']], // Thailand
  ['TR', ['tr']], // Turkey
  ['VN', ['en', 'vi']], // Vietnam
  ['ZA', ['en']], // South Africa
];

// An array of test AEM markets where components will be published
const TEST_MARKETS = [
  ['AQ', ['de', 'it']], // Antarctica
];

// Helper function to convert an array of market properties to an array of oneweb market objects
// E.g.: ['BE', ['nl', 'fr']] -> { country: 'BE', language: 'nl }, { country: 'BE', language: 'fr }
const getOnewebMarkets = (markets) => {
  const convertToOnewebMarket = (country, languages) => languages.map((language) => ({ country, language }));

  const onewebMarkets = [];

  markets.forEach((market) => onewebMarkets.push(...convertToOnewebMarket(...market)));

  return onewebMarkets;
};

// Combine real and test markets into one marketAvailability array, which will be used in oneweb manifest files
module.exports = [...getOnewebMarkets(REAL_MARKETS), ...getOnewebMarkets(TEST_MARKETS)];
